import React, { useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Space,
  Select,
} from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const CategoryForm = ({
  initialValues,
  onSubmit,
  onCancel,
  categories = [],
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: 'Please enter category name' }]}
      >
        <Input placeholder="Enter category name" />
      </Form.Item>

      <Form.Item
        name="description"
        label="Description"
      >
        <TextArea
          placeholder="Enter category description"
          rows={4}
        />
      </Form.Item>

      <Form.Item
        name="parentCategoryId"
        label="Parent Category"
      >
        <Select
          placeholder="Select parent category (optional)"
          allowClear
        >
          {categories.map(category => (
            <Option key={category.id} value={category.id}>{category.name}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default CategoryForm;
